import { useCallback, useState } from "react"
import axiosInstance from "../../../../services/axios-client"
import { toast } from "react-toastify"

const useListGroupBu = () => {
    const [payload, setPayload] = useState([])
    const [loadingPagestate, setLoadingPage] = useState(false)

    const getListGroupBu = useCallback(async () => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get('/auth/group-business-units')
            if (res.status === 200) {
                setPayload(res.data.data)
                setLoadingPage(false)
                return res.data.data
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }, [])

    const deleteGroupBusinessUnit = useCallback(async (id, onSuccess) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.delete(`/auth/group-business-units/${id}`)
            if (res.status === 204) {
                toast.success("Success Delete Group Business Unit")
                if (onSuccess) {
                    onSuccess()
                }
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }, [])

    return {
        payload,
        getListGroupBu,
        deleteGroupBusinessUnit,
        loadingPagestate
    }
}

export default useListGroupBu